import { useGetApiV1ClassroomdisciplineSharedTeachers } from '@/shared/api/generated';
import { mapDropdownOptions, useDebouncedFilter } from '@/shared/ui/molecules/LookupAutocomplete';

/**
 * Busca de professores por texto (debounce + mínimo de 3 caracteres) para o
 * autocomplete de professor. Consome o lookup `shared/teachers` do Kubb.
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useTeacherSearchDropdown(filter = '') {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedTeachers(
    isReady ? { Search: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
